var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{directives:[{name:"my-section-class",rawName:"v-my-section-class"}],staticClass:"o-section c-future",attrs:{"id":"future-energy"}},[_c('div',{staticClass:"c-future__component"},[_c(_vm.currentView,{tag:"component",on:{"prosumer-active":_vm.onProsumerActive}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d8e0364","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","source":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/single/MyFuture.vue
// module id = 829
// module chunks = 0